module.exports = __webpack_public_path__ + "img/model-top.97a6c106.png";